var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Nombre del aspecto (*)"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.nombre,
                expression: "model.nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("nombre del aspecto") },
            attrs: { name: "nombre del aspecto" },
            domProps: { value: _vm.model.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "nombre", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("nombre del aspecto")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("nombre del aspecto"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Descripción del aspecto"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.descripcion,
                expression: "model.descripcion",
              },
            ],
            staticClass: "input",
            attrs: { name: "descripción del atributo" },
            domProps: { value: _vm.model.descripcion },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "descripcion", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [
            _vm._v(
              "(Opcional) Describa el significado del conjunto de atributos"
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.edit
        ? _c("div", { staticClass: "field is-clearfix" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary is-pulled-right",
                on: { click: _vm.submitEdit },
              },
              [
                _c("i", { staticClass: "fas fa-save fa-fw" }),
                _vm._v("Guardar\n    "),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Nombre del atributo (*)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.title,
                    expression: "input.title",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.errors.has("Título atributo") },
                attrs: { name: "Título atributo" },
                domProps: { value: _vm.input.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input, "title", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.has("Título atributo")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("Título atributo"))),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Clave del atributo (*)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.key,
                    expression: "input.key",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/,
                    },
                    expression:
                      "{ required: true, regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/ }",
                  },
                ],
                staticClass: "input is-mono",
                class: { "is-danger": _vm.errors.has("Clave atributo") },
                attrs: {
                  name: "Clave atributo",
                  readonly: !_vm.enableCustomKey,
                },
                domProps: { value: _vm.input.key },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input, "key", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v(
                  "Autogenerado por el nombre, si desea personalizarlo, haga clic en 'Personalizar clave'"
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("Clave atributo")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("Clave atributo"))),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Clave del atributo (*)"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c(
                  "b-checkbox",
                  {
                    model: {
                      value: _vm.enableCustomKey,
                      callback: function ($$v) {
                        _vm.enableCustomKey = $$v
                      },
                      expression: "enableCustomKey",
                    },
                  },
                  [_vm._v("Personalizar clave de atributo")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "help" }, [
                  _vm._v(
                    "Nota: no puede usar caracteres especiales, tildes, o espacios. Solamente se permiten minusculas, numeros y guiones"
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Tipo de atributo (*)"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.input.type,
                            expression: "input.type",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true },
                            expression: "{required:true}",
                          },
                        ],
                        class: { "is-danger": _vm.errors.has("Tipo atributo") },
                        attrs: { name: "Tipo atributo" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.input,
                              "type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null },
                          },
                          [_vm._v("Seleccione")]
                        ),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "string" } }, [
                          _vm._v("Texto"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "number" } }, [
                          _vm._v("Número"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "integer" } }, [
                          _vm._v("Número entero"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "boolean" } }, [
                          _vm._v("Binario"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "date" } }, [
                          _vm._v("Fecha"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "enum" } }, [
                          _vm._v("Opción"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.errors.has("Tipo atributo")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("Tipo atributo"))),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.input.type
              ? _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("b-field", { attrs: { label: "Acerca..." } }, [
                      _c(
                        "div",
                        { staticClass: "message is-small is-primary" },
                        [
                          _c("div", { staticClass: "message-body" }, [
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "string",
                                    expression: "input.type == 'string'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "Se aceptan textos como entradas en este atributo"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "number",
                                    expression: "input.type == 'number'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "Se aceptan números (con decimales) como entradas en este atributo"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "integer",
                                    expression: "input.type == 'integer'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "Se aceptan numeros enteros (sin decimales) como entradas en este atributo"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "boolean",
                                    expression: "input.type == 'boolean'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "La entrada es binario: Si/No - Verdadero/Falso"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "date",
                                    expression: "input.type == 'date'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "Se aceptan fechas con formato YYYY-MM-DD"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.input.type == "enum",
                                    expression: "input.type == 'enum'",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "Se elije una opción de una lista de valores. La lista se define en este formulario"
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.input.type == "enum"
            ? _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Lista de opciones (*)"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("div", { staticClass: "control is-expanded" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.input.optionInput,
                            expression: "input.optionInput",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder: "Escriba una opción",
                        },
                        domProps: { value: _vm.input.optionInput },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.addOption.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.input,
                              "optionInput",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-info",
                          on: { click: _vm.addOption },
                        },
                        [_vm._v("Agregar")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type == "enum"
            ? _c(
                "div",
                { staticClass: "field is-grouped is-grouped-multiline" },
                _vm._l(_vm.input.options, function (option, i) {
                  return _c("div", { key: option, staticClass: "control" }, [
                    _c("div", { staticClass: "tags has-addons" }, [
                      _c("span", { staticClass: "tag is-link" }, [
                        _vm._v(_vm._s(option)),
                      ]),
                      _vm._v(" "),
                      _c("a", {
                        staticClass: "tag is-delete",
                        on: {
                          click: function ($event) {
                            return _vm.removeOption(i)
                          },
                        },
                      }),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Descripcion del atributo (*)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.description,
                    expression: "input.description",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.errors.has("Descripcion atributo") },
                attrs: { name: "Descripcion atributo" },
                domProps: { value: _vm.input.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input, "description", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "span help" }, [
                _vm._v(
                  "Se utilizará para explicarle al usuario acerca de que significa el atributo"
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("Descripcion atributo")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("Descripcion atributo"))),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Atributo opcional"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c(
                  "b-checkbox",
                  {
                    model: {
                      value: _vm.input.optional,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "optional", $$v)
                      },
                      expression: "input.optional",
                    },
                  },
                  [_vm._v("Opcional")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "span help" }, [
                  _vm._v("Habilitelo si el atributo es opcional"),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "is-clearfix" }, [
            !_vm.edit
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary is-pulled-right",
                    on: { click: _vm.add },
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus fa-fw" }),
                    _vm._v("Agregar al listado\n        "),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "button is-primary is-pulled-right",
                    on: { click: _vm.addNewAttribute },
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus fa-fw" }),
                    _vm._v("Agregar al listado\n        "),
                  ]
                ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Listado de atributos"),
      ]),
      _vm._v(" "),
      _vm.edit
        ? _c("b-message", { attrs: { size: "is-small" } }, [
            _vm._v(
              "\n    Puede editar el nombre y la descripción del atributo haciendo clic en el icono\n    "
            ),
            _c("i", { staticClass: "fas fa-edit" }),
          ])
        : _c("b-message", { attrs: { size: "is-small" } }, [
            _vm._v(
              "Si quiere cambiar algun atributo que fue ingresado en el listado, eliminelo, y vuelvalo a crear."
            ),
          ]),
      _vm._v(" "),
      _c("table", { staticClass: "table is-bordered is-narrow is-fullwidth" }, [
        _c("thead", [
          _c("th", { attrs: { width: "150px" } }, [_vm._v("Clave")]),
          _vm._v(" "),
          _c("th", { attrs: { width: "180px" } }, [_vm._v("Nombre")]),
          _vm._v(" "),
          _c("th", [_vm._v("Tipo | Descripción")]),
          _vm._v(" "),
          _vm.edit
            ? _c(
                "th",
                { staticClass: "has-text-centered", attrs: { width: "40" } },
                [_c("i", { staticClass: "fas fa-edit" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
        ]),
        _vm._v(" "),
        _vm.model.atributos
          ? _c(
              "tbody",
              [
                _vm._l(_vm.model.atributos, function (atributo) {
                  return _c("tr", { key: atributo.key }, [
                    _c("td", [
                      _c("span", { staticClass: "is-mono" }, [
                        _vm._v(_vm._s(atributo.key)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("b", [_vm._v(_vm._s(atributo.title))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: atributo.required,
                              expression: "atributo.required",
                            },
                          ],
                          staticClass: "has-text-danger",
                        },
                        [_vm._v("*")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "is-size-7" }, [
                      _c("span", { staticClass: "tag" }, [
                        _vm._v(_vm._s(_vm.getType(atributo.type))),
                      ]),
                      _vm._v(" \n          "),
                      _c("i", [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !atributo.required,
                                expression: "!atributo.required",
                              },
                            ],
                            staticClass: "has-text-primary",
                          },
                          [_vm._v("(Opcional)")]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(atributo.description) +
                            "\n            "
                        ),
                        atributo.type == "enum"
                          ? _c("span", [
                              _c("br"),
                              _vm._v(" "),
                              _c("b", [_vm._v("Lista de opciones:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    atributo.parametros.opciones.join(" • ")
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.edit
                      ? _c("td", { staticClass: "has-text-centered" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editAtributo(atributo)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-edit" })]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", { staticClass: "has-text-centered" }, [
                      _vm.edit
                        ? _c(
                            "a",
                            {
                              staticClass: "has-text-danger",
                              on: {
                                click: function ($event) {
                                  return _vm.showDeleteAtributo(atributo.key)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "has-text-danger",
                              on: {
                                click: function ($event) {
                                  return _vm.removeAtributos(atributo.key)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.model.atributos.length == 0
                  ? _c("tr", [_vm._m(3)])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "button",
            {
              staticClass: "button is-primary is-fullwidth",
              attrs: { disabled: _vm.model.atributos.length == 0 },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-save fa-fw" }),
              _vm._v("Guardar\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.deleteAtributo.showModal },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.deleteAtributo, "showModal", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("h1", { staticClass: "title is-3 has-text-centered" }, [
                _vm._v("Eliminar aspecto"),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "subtitle is-5 has-text-centered" }, [
                _vm._v("¿Está seguro?"),
              ]),
              _vm._v(" "),
              _c("b-message", { attrs: { type: "is-danger" } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "tag is-rounded is-pulled-right is-black is-mono",
                  },
                  [_vm._v(_vm._s(_vm.deleteAtributo.selected))]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "title is-4 has-text-danger" }, [
                  _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                  _vm._v(" Atención\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("p", [
                    _vm._v(
                      "\n            La acción que esta por realizar tiene un efecto importante de sus documentos con el aspecto\n            "
                    ),
                    _c("b", [_vm._v(_vm._s(_vm.model.nombre))]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "De proceder con la eliminación, se perderán todos los metadatos de los documentos asociados a este atributo."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("i", { staticClass: "fas fa-exclamation-circle" }),
                    _vm._v(
                      " Puede crear otro aspecto que reemplace el actual para no perder los datos asociados a los documentos afectados.\n          "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "buttons is-centered" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-light",
                    on: {
                      click: function ($event) {
                        _vm.deleteAtributo.showModal = false
                      },
                    },
                  },
                  [_vm._v("Cancelar")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-danger",
                    on: { click: _vm.submitDeleteAtributo },
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash" }),
                    _vm._v(" Eliminar\n        "),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.editingAtributo.showModal },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.editingAtributo, "showModal", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "box" }, [
            _c(
              "h1",
              {
                staticClass:
                  "tag is-rounded is-pulled-right is-primary is-mono",
              },
              [_vm._v(_vm._s(_vm.editingAtributo.selected))]
            ),
            _vm._v(" "),
            _c("h1", { staticClass: "subtitle is-4" }, [
              _vm._v("Editando aspecto"),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Nombre del atributo (*)"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editingAtributo.title,
                      expression: "editingAtributo.title",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}",
                    },
                  ],
                  staticClass: "input",
                  class: {
                    "is-danger": _vm.errors.has("Nuevo titulo atributo"),
                  },
                  attrs: { name: "Nuevo título atributo" },
                  domProps: { value: _vm.editingAtributo.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editingAtributo,
                        "title",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.has("Nuevo titulo atributo")
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("Nuevo titulo atributo"))),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Descripción del atributo (*)"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editingAtributo.description,
                      expression: "editingAtributo.description",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}",
                    },
                  ],
                  staticClass: "input",
                  class: {
                    "is-danger": _vm.errors.has("Nueva descripcion atributo"),
                  },
                  attrs: { name: "Nueva descripcion atributo" },
                  domProps: { value: _vm.editingAtributo.description },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editingAtributo,
                        "description",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "span help" }, [
                  _vm._v(
                    "Se utilizará para explicarle al usuario acerca de que significa el atributo"
                  ),
                ]),
                _vm._v(" "),
                _vm.errors.has("Nueva descripcion atributo")
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(
                        _vm._s(_vm.errors.first("Nueva descripcion atributo"))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Atributo opcional"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c(
                    "b-checkbox",
                    {
                      model: {
                        value: _vm.editingAtributo.opcional,
                        callback: function ($$v) {
                          _vm.$set(_vm.editingAtributo, "opcional", $$v)
                        },
                        expression: "editingAtributo.opcional",
                      },
                    },
                    [_vm._v("Opcional")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "span help" }, [
                    _vm._v("Habilitelo si el atributo es opcional"),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field is-clearfix" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary is-pulled-right",
                  attrs: { disabled: _vm.model.atributos.length == 0 },
                  on: { click: _vm.submitEditAtributo },
                },
                [
                  _c("i", { staticClass: "fas fa-save fa-fw" }),
                  _vm._v("Guardar\n        "),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5" }, [
      _c("i", { staticClass: "fas fa-plus fa-fw" }),
      _vm._v("Agregar atributos\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "help" }, [
      _vm._v("\n          Agregue a la lista haciendo clic en\n          "),
      _c("b", [_vm._v("Agregar")]),
      _vm._v(", o presionando la tecla\n          "),
      _c("b", [_vm._v("ENTER")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      { staticClass: "has-text-centered", attrs: { width: "40" } },
      [_c("i", { staticClass: "fas fa-times" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "has-text-centered", attrs: { colspan: "6" } },
      [
        _c("section", { staticClass: "section is-mono" }, [
          _c("span", { staticClass: "tag is-rounded is-medium" }, [
            _vm._v("No se han creado atributos"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }